import { render, staticRenderFns } from "./multichoice.vue?vue&type=template&id=d86cecc6&scoped=true&"
import script from "./multichoice.vue?vue&type=script&lang=js&"
export * from "./multichoice.vue?vue&type=script&lang=js&"
import style0 from "./multichoice.vue?vue&type=style&index=0&id=d86cecc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86cecc6",
  null
  
)

export default component.exports